<template>
  <component
    :is="tag"
    class="t-text font-sans subpixel-antialiased tracking-normal"
    :class="[
      VariantClasses[variant],
      ColorVariantClasses[color],
      LeadingClasses[leading],
      ClampClasses[clamp],
      SizeClasses[size],
      classes,
    ]"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type {
  TTextVariant,
  TTextTag,
  TTextColor,
  TTextLeading,
  TTextClamp,
  TTextSize,
} from './constants/types'
import {
  VariantClasses,
  ColorVariantClasses,
  LeadingClasses,
  ClampClasses,
  SizeClasses,
  MarginClasses,
} from './constants/constants'

export interface TText_Props {
  tag?: TTextTag
  variant?: TTextVariant
  color?: TTextColor
  leading?: TTextLeading
  clamp?: TTextClamp
  size?: TTextSize
  classes?: String
}

withDefaults(defineProps<TText_Props>(), {
  tag: 'p',
  variant: 'normal',
  color: 'gray900',
  leading: 'normal',
  clamp: 'clamp0',
  size: 'base',
  classes: rawProps => {
    return MarginClasses[rawProps.size as TTextSize]
  },
})
</script>
